/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReportGrammarRules } from '../../../../../../../redux/config/customReport/types'
import { CustomReportCategory } from '../../../../../../../redux/context/customReports/typesCategory'
import { NodesById, NormalizedBuilderNode, VisitorContext } from '../types'
import { NormalizedAbstractVisitor } from './NormalizedAbstractVisitor'

export class NormalizedExportVisitor extends NormalizedAbstractVisitor<CustomReportCategory> {
  constructor(rules: ReportGrammarRules, nodesById: NodesById) {
    super(rules, nodesById, true) // Traverse all nodes
  }

  /**
   * Vie puun CustomReportCategory-muotoon
   * @param rootNodeId Aloitussolmun ID
   * @returns CustomReportCategory-muotoinen puurakenne
   */
  public export(rootNodeId: string): CustomReportCategory {
    return this.visit(rootNodeId)
  }

  /**
   * Vie lasten alipuut CustomReportCategory-muotoon
   * @param nodeId Vanhemman ID
   * @returns Array of CustomReportCategory
   */
  public exportChildren(nodeId: string): CustomReportCategory[] {
    const childIds = this.getChildIds(nodeId)
    return childIds.map(childId => this.visit(childId))
  }

  // Vierailumetodit eri solmutyypeille - kaikki käyttävät samaa convertToCustomReportCategory-metodia
  visitRootNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  visitCompanyNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  visitDimensionNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  visitPeriodGroupNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  visitFunctionNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  visitReferenceNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  visitKeyFigureNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  visitFormulaNode(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    return this.convertToCustomReportCategory(node, context)
  }

  /**
   * Muuntaa normalisoidun solmun CustomReportCategory-muotoon
   */
  private convertToCustomReportCategory(node: NormalizedBuilderNode, context: VisitorContext): CustomReportCategory {
    // Poistetaan normalisoidun rakenteen kentät
    const { expanded, dragProps, dragHandleProps, isDragging, parentId, childIds, ...rest } = node

    // Luodaan uusi CustomReportCategory-objekti ja haetaan lapset rekursiivisesti
    return {
      ...rest,
      children:
        childIds && childIds.length > 0
          ? childIds.map((childId: string) => this.visitNodeById(childId, context))
          : undefined
    }
  }
}
